import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Usa localStorage come storage
import rootReducer from "./rootReducer";

// Configurazione di redux-persist
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["config", "generalConfig", "catalogues", "theme", "licenses"],
    blacklist: ["analytics"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configura lo store con Redux Toolkit
const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignora più azioni e percorsi di stato per evitare problemi di serializzabilità
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "analytics/SET_ANALYTICS_DATA",
                    "analytics/SET_LINE_GLASS_MODEL",
                    "analytics/OVERVIEW_DATA",
                    "analytics/GLASS_ARRAY",
                    "analytics/VAR_ARRAY",
                    "catalogues/SET_SELECTED_CATALOGUES",
                    "catalogues/SET_SELECTED_CATALOGUE"
                ],
                ignoredPaths: [
                    "analytics.overview",
                    "analytics.glassArray",
                    "analytics.variantArray",
                    "catalogues.selectedCatalogs",
                    "catalogues.selectedCatalog"
                ],
                // Aumenta la soglia di avviso per ambienti di sviluppo
                warnAfter: 500
            },
        }),
});

// Configura redux-persist
export const persistor = persistStore(store);
export default store;